import EventHandler from '@pixelunion/events';
import { transition } from '@pixelunion/animations';

export default class NewsletterPopup {
  constructor() {
    this.events = new EventHandler();
    this.popup = document.querySelector('[data-popup-opened]');
    this.popupCloseBtn = document.querySelector('[data-popup-close]');
    this.delay = Shopify.theme_settings.newsletter_popup_seconds * 1000;
    this.days = parseInt(Shopify.theme_settings.newsletter_popup_days, 10);
    this.animatePopup = transition({ el: this.popup, state: 'closed' });

    if (this.getCookie() === -1) {
      setTimeout(() => {
        this.popup.dataset.popupOpened = true;
        this.animatePopup.animateTo('open');
      }, this.delay);
    }

    this.events.register(this.popupCloseBtn, 'click', () => {
      this.popup.dataset.popupOpened = false;
      this.animatePopup.animateTo('closed');
      this.setCookie();
    });

    this._closeEsc = e => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        this.popup.dataset.popupOpened = false;
        this.animatePopup.animateTo('closed');
        this.setCookie();
      }
    };

    this.closeEscEvent = this.events.register(window, 'keydown', e => this._closeEsc(e));
  }

  setCookie() {
    if (this.days !== 0) {
      const date = new Date();
      date.setTime(date.getTime() + (this.days * 24 * 60 * 60 * 1000));
      document.cookie = `hide-popup=true; expires="${date.toGMTString()}"`;
    }
  }

  getCookie() {
    if (this.days !== 0) {
      const cookieArray = document.cookie.split(';').map(item => item.trim());
      return cookieArray.indexOf('hide-popup=true');
    }

    return -1;
  }

  unload() {
    if (this.events) {
      this.events.unregisterAll();
    }
  }
}
